












































































































































import { defineComponent, ref, watch } from '@vue/composition-api';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, min, numeric } from 'vee-validate/dist/rules';
import { Toggle } from '@/app/components';
import { urlValidator } from '@/app/validators';

extend('required', {
    ...required,
    message: '{_field_} is required',
});

extend('min', {
    ...min,
    message: '{_field_} must be longer than or equal to 8 characters.',
});

extend('numeric', {
    ...numeric,
    message: '{_field_} must be a number',
});

extend('url', { ...urlValidator, message: '{_field_} must be a valid IP address' });

export default defineComponent({
    name: 'RunnerTokens',
    components: { ValidationProvider, ValidationObserver, Toggle },
    props: {
        tokenGeneration: {
            type: Object,
        },
        generatedToken: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const observer = ref<any>(null);
        const tokenToCopy = ref<any>(null);

        watch(
            () => observer.value?.flags?.invalid,
            (newValue) => {
                if (typeof newValue === 'boolean') {
                    emit('validation-changed', newValue);
                }
            },
        );

        const copyToClipboard = () => {
            tokenToCopy.value = document.querySelector('#token');
            if (tokenToCopy.value.value) {
                tokenToCopy.value.setAttribute('type', 'text');
                tokenToCopy.value.select();
                document.execCommand('copy');
                tokenToCopy.value.setAttribute('type', 'hidden');
            }
        };

        return {
            observer,
            copyToClipboard,
        };
    },
});
